<template>
  <div class="compareListOffer">
    <div class="compareListOffer__wrapper">
      <div class="compareListOffer__fukidashiWrapper">
        <p class="compareListOffer__fukidashi">学校の主要情報が簡単に比較できる！</p>
      </div>
      <div class="compareListOffer__descriptionWrapper">
        <img src="/images/s/dot_left.png" class="compareListOffer__dotImg" />
        <p class="compareListOffer__description__text">
          会員限定の新機<span class="compareListOffer__description--letter7">能</span><br class="break332" /><span
            class="compareListOffer__description__colorText"
            >「学校比較<span class="compareListOffer__description--letter6">」</span></span
          >
        </p>
        <img src="/images/s/dot_right.png" class="compareListOffer__dotImg" />
      </div>
      <img src="/images/s/gakko_compare.png" class="compareListOffer__img" />
      <a class="compareListOffer__loginBtn" :href="compareLink" @click="$emit('click-go-compare', $event)"
        >比較機能を使ってみる</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompareOfferSp',
  props: {
    compareLink: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.compareListOffer {
  margin: 32px 0 20px;
  padding: 20px;
  background-color: #e7f6ff;
}

.compareListOffer__wrapper {
  @media (min-width: 428px) {
    max-width: 360px;
    margin: 0 auto;
  }
}

.compareListOffer__fukidashiWrapper {
  width: fit-content;
  margin-inline: auto;
  border-radius: 20px;
  background-color: #0b41a0;
}

.compareListOffer__fukidashi {
  position: relative;
  margin-bottom: 12px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  text-align: center;
  color: #fff;
  padding: 4px 12px;
}

.compareListOffer__fukidashi::before {
  content: '';
  position: absolute;
  bottom: -10px;
  left: calc(50% - 5px);
  border: 5px solid transparent;
  border-top: 5px solid #0b41a0;
}

.compareListOffer__img {
  display: block;
  width: 100%;
  aspect-ratio: 1.63 / 1;
}

.compareListOffer__descriptionWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.3;
  color: #24243f;
}

.compareListOffer__dotImg {
  width: 18px;
  height: 24px;
}

.compareListOffer__description__text {
  padding: 0 8px;
  text-align: center;
}

.compareListOffer__description--letter6 {
  letter-spacing: -6px;
}

.compareListOffer__description--letter7 {
  letter-spacing: -7px;
}

.compareListOffer__description__colorText {
  font-size: 17px;
  color: #de30ca;
}

.break332 {
  display: none;
}

@media (max-width: 332px) {
  .break332 {
    display: block;
  }
}

.compareListOffer__loginBtnWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.compareListOffer__loginBtn {
  display: block;
  border-radius: 4px;
  border: 1px solid #0ca5e6;
  color: #0ca5e6;
  background-color: #fff;
  padding: 12px;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  max-width: 360px;
  box-sizing: border-box;
  line-height: 1;
}
</style>
